import { jdiColorFetch } from "@/apis/colorFetchV2";
interface IPromoReq {
  cartuuid: string;
  omittedDetail: boolean;
  userActionId: string;
  verticalTag: string;
  operations: {
    // 券促
    coupons?: { batchId?: string; couponId?: string; endTime?: string }[];
    // 总促
    products?: { skuId?: string }[];
    promotions?: {
      id?: string;
      promotionId?: string;
    }[];
  };
  shipmentType?: string;
}

export const fetchPromoInfo = async ({ cartuuid, omittedDetail = false, userActionId, verticalTag, operations, shipmentType }: IPromoReq) => {
  return await jdiColorFetch("trade_cart_modifyItem", {
    method: "POST",
    bodyQuery: {
      cartuuid,
      omittedDetail,
      verticalTag,
      operations,
      userActionId,
      shipmentType,
    },
  });
};
